/**
 * Describe all records fetched from API and then used within Coordinator
 * App.
 */

import * as I from "immutable";

export const APIError = I.Record({
  message: null,
});

export const AppData = I.Record({
  destinationType: null,
  destinationTypeEditable: null,
  destinationTypePhysical: null,
  serviceType: null,
  cancelReason: null,
  weekdayType: null,

  defaultDrivingTimeSec: null,
  firstVisitDurationMultiplier: null,
  visitDurationMultiplier: null,
});

export const Assignee = I.Record({
  id: null,

  email: null,
  fullName: null,

  fieldEmployeeType: null,
  role: null,
  inTraining: null,

  assignedTo: null,
});

export const AuthUser = I.Record({
  id: null,

  email: null,
  fullName: null,

  role: null,
});

export const Destination = I.Record({
  id: null,

  slot: null,
  type: null,
  title: null,
  address: null,
  latitude: null,
  longitude: null,

  readFirstNote: null,

  duration: null,
  estStartTime: null,
  estEndTime: null,
  checkinTime: null,
  checkoutTime: null,

  traineePickedUp: null,

  isFirstMaiVisit: null,
  skipFirstVisitMul: null,
  isRevisit: null,

  notes: null,
  externalNotes: null,
  gardenerNotes: null,
  importantNotes: null,
  schedulerNotes: null,

  route: null,
  tasks: null,

  house: null,
  visitTemplate: null,
  cancelReason: null,
});


export const House = I.Record({
  id: null,

  fullAddress: null,
  address: null,
  city: null,
  state: null,
  zipCode: null,
  longitude: null,
  latitude: null,

  customer: null,
  slug: null,

  timeConstraints: null,
});

export const OrderVisit = I.Record({
  id: null,
  name: null,
});

export const Order = I.Record({
  id: null,
  house: null,

  createdAt: null,
  productName: null,
  totalCost: null,
  status: null,
  newVisits: null,
  orderVisitTemplates: null,
});

export const Route = I.Record({
  id: null,

  assignments: null,
  destinations: null,
  overlappedDestinations: null,

  balance: null,
  correctCheckinOrder: null,
  date: null,
  delay: null,
  manpower: null,
  target: null,
  type: null,
  title: null,
  readOnly: null,
});

export const SchedulerRoute = I.Record({
  id: null,

  crewType: null,
  title: null,
  week: null,
  weekday: null,

  assignments: null,
});

export const Task = I.Record({
  id: null,
  position: null,

  title: null,
  description: null,

  completed: null,
  visible: null,
});

export const TimeConstraint = I.Record({
  id: null,

  label: null,
  weekday: null,

  timeStart: null,
  timeEnd: null,
});

export const VisitTemplate = I.Record({
  id: null,

  expectedDuration: null,
  notes: null,
});

export const User = I.Record({
  id: null,
  gid: null,
  workerId: null,

  email: null,
  fullName: null,

  role: null,
  type: null,
  displayColor: null,
  inTraining: null,
  phoneNumber:  null,
  workPhoneNumber:  null,
});

export default {
  APIError,
  AppData,
  Assignee,
  AuthUser,
  Destination,
  House,
  Route,
  Task,
  VisitTemplate,
  User,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/Records.js
 **/